import React, { useState, useEffect, useContext, useRef } from 'react';
import Footer from '../components/footer';
import { listOrganizationalUnits } from '../services/api_org_unit';
import { AuthContext } from '../contexts/auth';
import { getCompanyAlerts, postAlertCompany, deleteAlertCompany, getCompanyAlertsReadbyList } from '../services/api_alerts';
import Swal from 'sweetalert2';
import Fetching from '../components/fetching';
import Toggle from '../components/toggle';
import Empty from '../components/empty';
import { Link } from 'wouter';
import PopoverComponentCustom from '../components/popover_component';
import AlertForm from '../components/form_alert_create';
import ComunicationsList from '../components/comunications_list';
import NotificationsList from '../components/notifications_list';


export default function BoardMessage() {
  const { token, profile } = useContext(AuthContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isLoadingOu, setIsLoadingOu] = useState(false);
  const [selectedToggleOption, setSelectedToggleOption] = useState('Comunicazioni');
  const [isLoadingComunications, setIsLoadingComunications] = useState(true);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const [isError, setIsError] = useState(false);
  const [units, setUnits] = useState([]);
  const [selectedCommunicationOption, setSelectedCommunicationOption] = useState({});
  const [comunications, setComunications] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [currentPageComunications, setCurrentPageComunications] = useState(1);
  const [totalPagesComunications, setTotalPagesComunications] = useState(0);
  const [currentPageNotifications, setCurrentPageNotifications] = useState(1);
  const [totalPagesNotifications, setTotalPagesNotifications] = useState(0);
  const [titleError, setTitleError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const [recipientError, setRecipientError] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [filter, setFilter] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const titleRef = useRef(null);
  const messageRef = useRef(null);
  const recipientRef = useRef(null);
  const [readByData, setReadByData] = useState([]);
  const [readByVisible, setReadByVisible] = useState(false);
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  const [loadingReadBy, setLoadingReadBy] = useState(false);
  const [errorLoadingReadby, setErrorLoadingReadby] = useState(false);
  const [currentPageReadby, setCurrentPageReadby] = useState(1);
  const [totalPagesReadby, setTotalPagesReadby] = useState(0);
  const abortControllerRef = useRef(null);

  const isProfileComplete = profile.has_complete_profile;
  
  
  useEffect(() => {
    const fetchUnits = async () => {
      setIsLoadingOu(true);
      setIsError(false);

      try {
        const response = await listOrganizationalUnits(token, true, null, 'shifts');

        setUnits(response.data || [] );
      } catch (error) {
        console.error('Error fetching units:', error);
        {(error.response.status !== 402) &&
          setIsError(true);
          setIsLoadingOu(false);
        }
      } finally {
        setIsLoadingOu(false);
      }
    };

    fetchUnits();
  }, [token]);

  const fetchAlerts = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setComunications([]);
    setNotifications([]);

    if (selectedToggleOption === 'Comunicazioni') {
      setIsLoadingComunications(true);
      try {
        const comunicationsResults = await getCompanyAlerts(
          token,
          currentPageComunications,
          10,
          'comunication',
          'alerts',
          controller.signal
        );
        setComunications(comunicationsResults.results || []);
        setTotalPagesComunications(Math.ceil(comunicationsResults.count / 10));
        setIsLoadingComunications(false);
      } catch (error) {
        if (error.name !== 'CanceledError') {
          setIsLoadingComunications(false);
          console.error('Errore comunicazioni:', error);
        }
      }
    }

    if (selectedToggleOption === 'Notifiche') {
      setIsLoadingNotifications(true);
      try {
        const notificationsResult = await getCompanyAlerts(
          token,
          currentPageNotifications,
          20,
          'notification',
          'shifts',
          controller.signal
        );
        setNotifications(notificationsResult.results || []);
        setTotalPagesNotifications(Math.ceil(notificationsResult.count / 20));
      } catch (error) {
        if (error.name !== 'CanceledError') {
          console.error('Errore notifiche:', error);
        }
      } finally {
        setIsLoadingNotifications(false);
      }
    }
  };

  useEffect(() => {
    if (token) {
      fetchAlerts();
    }

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [token, selectedToggleOption, currentPageComunications, currentPageNotifications]);

  const handleNextPage = () => {
    if (selectedToggleOption === 'Comunicazioni') {
      if (currentPageComunications < totalPagesComunications) {
        setCurrentPageComunications(prevPage => prevPage + 1);
      }
    } else if (selectedToggleOption === 'Notifiche') {
      if (currentPageNotifications < totalPagesNotifications) {
        setCurrentPageNotifications(prevPage => prevPage + 1);
      }
    }
  };

  const handlePreviousPage = () => {
    if (selectedToggleOption === 'Comunicazioni') {
      if (currentPageComunications > 1) {
        setCurrentPageComunications(prevPage => prevPage - 1);
      }
    } else if (selectedToggleOption === 'Notifiche') {
      if (currentPageNotifications > 1) {
        setCurrentPageNotifications(prevPage => prevPage - 1);
      }
    }
  };

  const handleNextPageReadby = () => {
    if (currentPageReadby < totalPagesReadby) {
      setCurrentPageReadby(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPageReadby = () => {
    if (currentPageReadby > 1) {
      setCurrentPageReadby(prevPage => prevPage - 1);
    }
  };


  const handleOptionChange = (option) => {
    if (selectedOption === option) {
      setSelectedOption(null);
    } else {
      setSelectedOption(option);
      if (option !== 'employee') {
        setSelectedEmployees([]);
      }
      if (option !== 'unit') {
        setSelectedUnits([]);
        setSelectedCommunicationOption({});
      }
      if (option !== 'all') {
        
      }
      setRecipientError(null);
    }
  };

  const handleCheckboxChange = (event) => {
    setFilter(event.target.value);
  };

  const handleEmployeeSelection = (employee) => {
    const selected = Array.isArray(employee) ? employee[0] : employee;
    if (!selected || !selected.id) return;
    
    if (Array.isArray(selectedEmployees)) {
      if (selectedEmployees.some((e) => e.id === selected.id)) {
        setSelectedEmployees(selectedEmployees.filter((e) => e.id !== selected.id));
      } else {
        setSelectedEmployees([...selectedEmployees, selected]);
      }
    } else {
      setSelectedEmployees([selected]);
    }
    setSearchQuery('');
  };
    
  const handleUnitSelection = (unit) => {
    if (selectedUnits.some((selectedUnit) => selectedUnit.id === unit.id)) {
      setSelectedUnits(selectedUnits.filter((selectedUnit) => selectedUnit.id !== unit.id));
    } else {
      setSelectedUnits([...selectedUnits, unit]);
    }
  };

  const handleCreateAlert = async (event) => {
    event.preventDefault();

    const title = event.target.elements.title.value;
    const message = event.target.elements.comment.value;

    let isValid = true;

    if (titleError) {
      setTitleError(null);
    }
    if (messageError) {
      setMessageError(null);
    }
    if (recipientError) {
      setRecipientError(null);
    }

    if (!title) {
      setTitleError('Compila il campo');
      if (titleRef.current) {
        titleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!message) {
      setMessageError('Compila il campo');
      if (isValid && messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!selectedOption) {
      setRecipientError('Seleziona almeno un destinatario');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    } else if (selectedOption === 'unit' && (!selectedUnits || selectedUnits.length === 0)) {
      setRecipientError('Seleziona almeno un\'unità');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    } else if (selectedOption === 'employee' && (!selectedEmployees || selectedEmployees.length === 0)) {
      setRecipientError('Seleziona almeno un dipendente');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    const newAlertData = {
      title,
      message,
      send_to_all: selectedOption === 'all',
      category: 'comunication',
      organizational_units: selectedOption === 'unit' ? selectedUnits.map(unit => unit.id) : [],
      employees: selectedOption === 'employee' ? selectedEmployees.map(employee => employee.id) : []
    };
    
    try {
      await postAlertCompany(token, newAlertData);

      setCurrentPageComunications(1);
      await fetchAlerts();

      Swal.fire({
        icon: 'success',
        title: 'Messaggio Inviato!',
        text: 'Il messaggio è stato inviato correttamente.',
        timer: 2500,
      });

      event.target.reset();
      setSelectedOption(null);
      setSelectedUnits([]);
      setSelectedEmployees([]);
      setSelectedCommunicationOption({});
    } catch (error) {
      console.error('Errore durante l\'invio del messaggio:', error);
      let errorMessage = 'Non è stato possibile inviare il messaggio. Per favore riprova.';
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];
  
        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });
  
        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };

  const handleShowDetails = (messageId) => {
    setShowDetails((prevDetailsVisibility) => ({
      ...prevDetailsVisibility,
      [messageId]: !prevDetailsVisibility[messageId]
    }));
  };

  const handleToggleChange = (option) => {
    setSelectedToggleOption(option);

    if (option === 'Comunicazioni') {
      setCurrentPageComunications(1);
      setIsLoadingComunications(true);
    } else {
      setCurrentPageNotifications(1);
      setIsLoadingNotifications(true);
    }
  };

  const handleDeleteAlert = async (id, title) => {
    Swal.fire({
      icon: "warning",
      title: 'Conferma eliminazione',
      text: `Stai eliminando l'avviso "${title}". Sei sicuro di voler procedere?`,
      showCancelButton: true,
      confirmButtonText: "Sì",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#d1d5db",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteAlertCompany(token, id);

          if (comunications.length === 1 && currentPageComunications > 1) {
            setCurrentPageComunications(prev => prev - 1);
          } else {
            await fetchAlerts();
          }
  
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Avviso eliminato con successo!",
            showConfirmButton: false,
            timer: 1500
          });
        } catch (error) {
          console.error('Errore durante l\'eliminazione:', error);
          let errorMessage = 'Non è stato possibile eliminare l\'avviso. Per favore riprova.';
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            const errorMessages = [];
      
            Object.keys(errorData).forEach((key) => {
              const messageArray = errorData[key];
              if (Array.isArray(messageArray)) {
                errorMessages.push(...messageArray);
              } else if (typeof messageArray === 'string') {
                errorMessages.push(messageArray);
              }
            });
      
            if (errorMessages.length > 0) {
              errorMessage = errorMessages.join(' ');
            }
          }
      
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: errorMessage,
            confirmButtonText: 'OK',
          });
        }
      };
    });
  };

  const handleToggleReadBy = (alertId) => {
    if (readByVisible && selectedAlertId === alertId) {
      setReadByVisible(false);
    } else {
      setSelectedAlertId(alertId);
      setCurrentPageReadby(1);
      setReadByVisible(true);
    }
  };

  useEffect(() => {
    const fetchReadByData = async () => {
      if (readByVisible && selectedAlertId) {
        try {
          setLoadingReadBy(true);
          setErrorLoadingReadby(false);
          const perPage = 20;
          const res = await getCompanyAlertsReadbyList(token, selectedAlertId, currentPageReadby, perPage, 'alerts');
          setReadByData(res.results || []);
          setTotalPagesReadby(Math.ceil(res.count / perPage));
        } catch (error) {
          console.error("Errore nel recupero dei dati:", error);
          setErrorLoadingReadby("Errore nel recupero dei dati.");
        } finally {
          setLoadingReadBy(false);
        }
      }
    };

    fetchReadByData();
  }, [currentPageReadby, readByVisible, selectedAlertId]);

  if (isError) return <div>Error loading data</div>;
 
  return (
    <div className="flex flex-col min-h-screen">
      <PopoverComponentCustom title='Bacheca Avvisi' />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="flex-grow mt-10 pb-8 px-8">
        <AlertForm
          titleError={titleError}
          setTitleError={setTitleError}
          messageError={messageError}
          setMessageError={setMessageError}
          recipientError={recipientError}
          selectedOption={selectedOption}
          selectedUnits={selectedUnits}
          selectedEmployees={selectedEmployees}
          units={units}
          filter={filter}
          searchQuery={searchQuery}
          isLoadingOu={isLoadingOu}
          handleOptionChange={handleOptionChange}
          handleUnitSelection={handleUnitSelection}
          handleEmployeeSelection={handleEmployeeSelection}
          handleCheckboxChange={handleCheckboxChange}
          handleCreateAlert={handleCreateAlert}
          token={token}
          titleRef={titleRef}
          messageRef={messageRef}
          recipientRef={recipientRef}
        />

        <div className='border border-gray-200 rounded-md shadow-sm p-5 mt-4'>
          <div className='justify-center flex w-full'>
            <Toggle
              color="indigo"
              gradeBgColor="600"
              optionLeft="Comunicazioni"
              optionRight="Notifiche"
              selectedOption={selectedToggleOption}
              onChange={handleToggleChange}
            />
          </div>

          {selectedToggleOption === 'Comunicazioni' ? (
            isLoadingComunications ? (
              <Fetching />
            ) : comunications.length === 0 ? (
              <Empty />
            ) : (
              <ComunicationsList
                messages={comunications}
                showDetails={showDetails}
                handleShowDetails={handleShowDetails}
                handleDeleteAlert={handleDeleteAlert}
                handleToggleReadBy={handleToggleReadBy}
                readByVisible={readByVisible}
                selectedAlertId={selectedAlertId}
                readByData={readByData}
                loadingReadBy={loadingReadBy}
                errorLoadingReadby={errorLoadingReadby}
                currentPageReadby={currentPageReadby}
                totalPagesReadby={totalPagesReadby}
                handleNextPageReadby={handleNextPageReadby}
                handlePreviousPageReadby={handlePreviousPageReadby}
                currentPage={currentPageComunications}
                totalPages={totalPagesComunications}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
              />
            )
          ) : isLoadingNotifications ? (
            <Fetching />
          ) : notifications.length === 0 ? (
            <Empty />
          ) : (
            <NotificationsList
              notifications={notifications}
              isLoading={isLoadingNotifications}
              currentPage={currentPageNotifications}
              totalPages={totalPagesNotifications}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
